import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { describe } from 'react-desc';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import getComponentFromProps from '@elliemae/ds-utilities/getComponentFromProps';
import Group from '@elliemae/ds-shared/GroupContext/Group';
import DSInputGroup from '../InputGroup/DSInputGroup.js';
import DSFloatingLabelInput from '../FloatingLabelInput/DSFloatingLabelInput.js';
export { default as DSError } from './Error/DSError.js';
import { props } from './props.js';
import { defaultProps } from './defaultProps.js';
export { FORMITEM_LAYOUT_VARIANTS } from './variants.js';
import { SuffixWrapper, SuffixInputWrapper, Suffix } from './Suffix/Suffix.js';
import '../InputGroup/AddonWrapper.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '../InputGroup/props.js';
import '../InputGroup/defaultProps.js';
import '../FloatingLabelInput/FloatingLabelInputImpl.js';
import '@elliemae/ds-text-wrapper';
import 'resize-observer';
import '../FloatingLabelInput/getSvgPath.js';
import '../RequiredMark/RequiredMark.js';
import './Label/DSLabel.js';
import 'prop-types';
import '@elliemae/ds-truncated-tooltip-text';
import '../TextBox/DSTextBox.js';
import '../Input/DSInput.js';
import '../Input/InputImpl.js';
import '@babel/runtime/helpers/esm/typeof';
import 'lodash';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import '../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../Input/showEllipsis.js';
import './Feedback.js';
import 'styled-components';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var blockName = 'form-item';
var Wrapper = aggregatedClasses('div')(blockName, null, function (_ref) {
  var leftLabel = _ref.leftLabel,
      variant = _ref.variant;
  return _defineProperty({
    'with-left-label': leftLabel
  }, variant, variant);
});
var WrapperContent = aggregatedClasses('div')("".concat(blockName, "-content"));
var WrapperContentGroup = aggregatedClasses('fieldset')("".concat(blockName, "-content"));

var DSFormItemLayout = function DSFormItemLayout(_ref3) {
  var leftLabel = _ref3.leftLabel,
      floatingLabel = _ref3.floatingLabel,
      name = _ref3.name,
      id = _ref3.id,
      value = _ref3.value,
      InputComponent = _ref3.inputComponent,
      LabelComponent = _ref3.labelComponent,
      FeedbackComponent = _ref3.feedbackComponent,
      labelText = _ref3.labelText,
      truncateText = _ref3.truncateText,
      hasError = _ref3.hasError,
      validationState = _ref3.validationState,
      validationMessage = _ref3.validationMessage,
      feedbackMessage = _ref3.feedbackMessage,
      readOnly = _ref3.readOnly,
      focused = _ref3.focused,
      type = _ref3.type,
      autoFocus = _ref3.autoFocus,
      disabled = _ref3.disabled,
      onChange = _ref3.onChange,
      onBlur = _ref3.onBlur,
      onFocus = _ref3.onFocus,
      onPaste = _ref3.onPaste,
      onKeyUp = _ref3.onKeyUp,
      extraInputProps = _ref3.extraInputProps,
      extraContent = _ref3.extraContent,
      leftAddon = _ref3.leftAddon,
      rightAddon = _ref3.rightAddon,
      required = _ref3.required,
      optional = _ref3.optional,
      mask = _ref3.mask,
      useSubfix = _ref3.useSubfix,
      suffix = _ref3.suffix,
      variant = _ref3.variant,
      containerProps = _ref3.containerProps,
      rest = _objectWithoutProperties(_ref3, ["leftLabel", "floatingLabel", "name", "id", "value", "inputComponent", "labelComponent", "feedbackComponent", "labelText", "truncateText", "hasError", "validationState", "validationMessage", "feedbackMessage", "readOnly", "focused", "type", "autoFocus", "disabled", "onChange", "onBlur", "onFocus", "onPaste", "onKeyUp", "extraInputProps", "extraContent", "leftAddon", "rightAddon", "required", "optional", "mask", "useSubfix", "suffix", "variant", "containerProps"]);

  var isGroup = InputComponent.type === /*#__PURE__*/React.createElement(Group, null).type;
  var floatingLabelOverride = floatingLabel === 'UNSAFE';
  var WrapperContentComp = !isGroup ? WrapperContent : WrapperContentGroup; // group the input props to not duplicate it inside the specific inputComponent (floating or not)

  var inputProps = _objectSpread(_objectSpread({}, extraInputProps), {}, {
    disabled: disabled,
    hasError: hasError || validationState === 'error',
    id: id,
    name: name,
    type: type,
    autoFocus: autoFocus,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onPaste: onPaste,
    onKeyUp: onKeyUp,
    readOnly: readOnly,
    value: value,
    mask: mask,
    useSubfix: useSubfix,
    variant: variant,
    required: required
  }, rest);

  var renderInput = function renderInput(Input) {
    return leftAddon || rightAddon ? /*#__PURE__*/React.createElement(DSInputGroup, {
      leftAddon: leftAddon,
      rightAddon: rightAddon,
      variant: variant
    }, Input) : Input;
  };

  var renderFloating = /*#__PURE__*/React.createElement(DSFloatingLabelInput, _extends({}, inputProps, {
    extraInputProps: extraInputProps,
    focused: focused,
    inputComponent: InputComponent,
    labelComponent: LabelComponent,
    labelText: labelText,
    optional: optional,
    required: required,
    variant: variant
  }));
  var InputWithLabel = floatingLabelOverride ? renderInput(renderFloating) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LabelComponent, {
    htmlFor: id || name,
    label: labelText,
    optional: optional,
    required: required,
    isGroup: isGroup,
    truncateText: truncateText
  }), renderInput(getComponentFromProps(InputComponent, inputProps)));

  if (suffix) {
    return /*#__PURE__*/React.createElement(Wrapper, _extends({
      classProps: {
        disabled: disabled,
        readOnly: readOnly,
        hasError: hasError,
        leftLabel: leftLabel,
        variant: variant
      }
    }, containerProps), /*#__PURE__*/React.createElement(SuffixWrapper, {
      className: "suffix-wrapper"
    }, /*#__PURE__*/React.createElement(SuffixInputWrapper, {
      className: "suffix-input-wrapper"
    }, /*#__PURE__*/React.createElement(WrapperContentComp, null, InputWithLabel, extraContent), /*#__PURE__*/React.createElement(FeedbackComponent, {
      hasError: hasError,
      text: validationState || hasError ? validationMessage : feedbackMessage
    })), /*#__PURE__*/React.createElement(Suffix, {
      className: "suffix-label",
      label: !!labelText,
      withFeedback: Boolean(validationMessage || feedbackMessage)
    }, suffix)));
  }

  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    classProps: {
      disabled: disabled,
      readOnly: readOnly,
      hasError: hasError,
      leftLabel: leftLabel,
      variant: variant
    }
  }, containerProps), /*#__PURE__*/React.createElement(WrapperContentComp, null, InputWithLabel, extraContent), /*#__PURE__*/React.createElement(FeedbackComponent, {
    hasError: hasError,
    text: validationState || hasError ? validationMessage : feedbackMessage
  }));
};

DSFormItemLayout.propTypes = props;
DSFormItemLayout.defaultProps = defaultProps;
var DSFormItemLayoutWithSchema = describe(DSFormItemLayout);
DSFormItemLayoutWithSchema.propTypes = props;

export default DSFormItemLayout;
export { DSFormItemLayoutWithSchema };
//# sourceMappingURL=DSFormItemLayout.js.map
